import Constants from '@/Constants';
import { ProgramClass } from '@/models/ProgramClass';
import { FullConfigurationWithExtraData } from '@/models/SWRCache';
import { useSWRConfig } from 'swr';
import { useGet } from './useGet';

interface Props {
    programClassId?: number;
    withEnrollmentsCount?: boolean;
    withWorkshopContent?: boolean;
}

export const useProgramClass = ({ programClassId, withEnrollmentsCount, withWorkshopContent }: Props) => {
    const keyURI = `${
        Constants.LMS_PROGRAM_CLASS_URI
    }/${programClassId}?withEnrollmentsCount=${!!withEnrollmentsCount}&withWorkshopContent=${!!withWorkshopContent}`;

    const { cache } = useSWRConfig() as FullConfigurationWithExtraData;

    const { data, mutate, revalidateResult, loading, hasError } = useGet<ProgramClass>(programClassId ? keyURI : null);

    const deleteProgramClassKey = () => {
        cache.delete(keyURI);
    };

    return {
        programClass: data,
        isLoading: loading,
        mutate,
        revalidateResult,
        hasError,
        deleteProgramClassKey,
    };
};
